import styled from "styled-components";

export const Container = styled.span`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
